// extracted by mini-css-extract-plugin
module.exports = {"selected":"NavItems_selected__67RmP","notSelected":"NavItems_notSelected__rQfVn"};